import api from './api';

const getUserInfo = async () => {
    try {
        return await api.get('user/dashboard')
            .then(function (response) {
                let user = response.data.user;
                user.isGerente = (user.perfil === 'gerente');
                user.isSuperintendente = (user.perfil === 'superintendente');
                user.isDiretor = (user.perfil === 'diretor');
                user.isMaster = (user.perfil === 'master');
                user.isUserEspecial = (user.perfil === 'master') || (user.perfil === 'gp') || (user.perfil === 'coordenador');

                return user;
            });
    } catch (err) {
        console.error(err);
    }
};

export default getUserInfo;
